<template src="./vehicleassets.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
var moment = require("moment");
export default {
  props: ["AssetsList"],
  components: {
    DocumentPopup,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  //props: ["VehicleId"],
  data() {
    return {
      ImageEndpoint: Endpoints.Helper.Image + "/",
    };
  },
  mounted() {
    setTimeout(() => {
      this.VehicleId = this.$route.params.VehicleId;    
    }, 4000);
    var CompanyData = JSON.parse(localStorage.getItem("Company"));    
  },
  methods: {
       
  },
};
</script>
<style scoped>
.download-excel-btn {
  float: right;
  margin-right: 10px;
}
</style>
